<!--
 * @Author: your name
 * @Date: 2020-12-29 16:05:36
 * @LastEditTime: 2021-01-09 10:34:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /java-pc/src/views/home/Home.vue
-->
<template>
  <!-- <div class="home_adv_con" v-show="advTop.show_switch && route.fullPath == '/index'">
    <div class="home_adv" :style="{ backgroundImage: 'url(' + advTop.imgUrl + ')' }" @click="navTo">
      <div class="adv1200">
        <div class="close1" @click.stop="advTop.show_switch = false">×</div>
      </div>
    </div>
  </div> -->
  <div>
    <!-- 电梯导航start -->

    <!-- 电梯导航end -->
    <div>

      <!-- <div class="bottom_line"></div> -->
      <router-view v-if="isRouterAlive"></router-view>

    </div>
  </div>

  <!-- <NavTopBar />
  <SldHomeTopSearch />
  <NavCatHeader />
  <div class="bottom_line"></div> 
  <router-view v-if="isRouterAlive"></router-view>
  <FooterService />
  <FooterLink /> -->
</template>

<script>
import { useRoute } from 'vue-router'
import NavTopBar from '../../components/NavTopBar'
import SldHomeTopSearch from '../../components/SldHomeTopSearch'
import NavCatHeader from '../../components/NavCatHeader'
import FooterService from '../../components/FooterService'
import FooterLink from '../../components/FooterLink'
import { ref, getCurrentInstance, onMounted } from 'vue'
export default {
  name: "Home",
  components: {
    // NavTopBar,
    // SldHomeTopSearch,
    // NavCatHeader,
    // FooterService,
    // FooterLink
  },
  setup() {
    const close_layer_icon = require("@/assets/coupon/close_layer_icon.png");
    const route = useRoute();
    const isRouterAlive = true;
    const { proxy } = getCurrentInstance();
    const advTop = ref({});
    const activeIndex = ref(0);
    const liftData = ref([]);
    const closeAd = () => {
      // 隐藏广告
      document.querySelector(".home_adv_con").style.display = "none";
    };
    const getAdv = () => {
      proxy
        .$get("v3/system/front/deco/firstAdv", {
          type: 2,
        })
        .then((res) => {
          if (res.state == 200) {
            advTop.value = JSON.parse(res.data.data.replace(/&quot;/g, '"'));
          }
        });
    };
    const handleLiftData = (e) => {
      console.log("liftData", e);
      liftData.value = e;
      // console.log(33,liftData.value)
    };
    const navTo = () => {
      proxy.$diyNavTo(advTop.value);
    };

    onMounted(() => {
      // getAdv();
      // liftData.value = props.decorateData.data.filter(
      //   (i) => i.json_data.type == "text_title"
      // );
      // console.log(liftData.value);
      // liftData.value.forEach((item, index) => {
      //   const scrollContainer = document.querySelector(
      //     "#scroll" + item.json_data.id
      //   );
      //   console.log(scrollContainer);
      //   scrollContainer.addEventListener("scroll", handleScroll);
      // });
    });

    return {
      isRouterAlive,
      advTop,
      close_layer_icon,
      activeIndex,
      liftData,
      navTo,
      route,
      closeAd,
      handleLiftData,
    };
  },
};
</script>
<style>
.bottom_line {
  width: 100%;
}

.dianti_wrap {
  position: absolute;
  top: 50%;
  width: 100%;
  /* left: 194px; */
  z-index: 9999;
  /* width: 1336px; */
  /* display: flex; */
  /* justify-content: center; */
}

.dianti_center {
  display: flex;
  justify-content: center;
}

.lift_item {
  font-family: Microsoft YaHei,Microsoft YaHei ;
  font-weight: 400;
  font-size: 15px;
  color: #888e98;
  line-height: 22px;
  margin-bottom: 15px;
  /* text-align: end; */
}

.active {
  font-family: Microsoft YaHei,Microsoft YaHei ;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  line-height: 22px;
}

.home_adv_con {
  overflow: hidden;
  height: 100px;
  position: relative;
  margin: 0 auto;
  /* padding-bottom: 40px; */
}

.home_adv {
  width: 1920px;
  height: 100px;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -960px;
}

.adv1200 {
  width: 1920px;
  height: 100px;
  margin: 0 auto;
  position: relative;
}

.close1 {
  /* top: 15px;
  right: 15px;
  z-index: 2;
  position: absolute; */
  /* background: rgba(0, 0, 0, 0.5); */
  /* width: 30px; */
  /* height: 30px; */
  /* display: flex; */

  /* line-height: 22px;
  color: #fff;
  cursor: pointer;
  text-align: center;
  font-size: 17px;
  font-family: cursive; */
  /* img { */
    /* width: 30px; */
    /* height: 30px; */
    /* margin: auto; */
  /* } */
}
</style>
